function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  x1: "15.367%",
  y1: "117.683%",
  x2: "65.649%",
  y2: "31.432%",
  id: "icon-device--gaming_svg__a"
}, React.createElement("stop", {
  stopColor: "#51575D",
  offset: "0%"
}), React.createElement("stop", {
  stopColor: "#AEB7BD",
  offset: "100%"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(6 25.4)",
  fillRule: "nonzero",
  fill: "none"
}, React.createElement("path", {
  d: "M63.535 4.72c-.55.26-1.067.615-1.584.938H34.209c-.55-.323-1.035-.679-1.585-.937-8.374-3.816-18.268-.097-22.083 8.31a15.1 15.1 0 00-1.1 3.427H9.41L3.363 44.685c-.615 2.845.84 5.755 3.492 6.951l7.372 3.33c.776.356 1.616.55 2.457.55h.194a6.283 6.283 0 004.915-2.522l6.078-8.31a8.039 8.039 0 004.753 1.553c4.042 0 7.372-2.975 7.954-6.855h14.97c.615 3.88 3.945 6.855 7.987 6.855a8.039 8.039 0 004.753-1.552l6.079 8.31a6.283 6.283 0 004.914 2.521h.194c.841 0 1.682-.194 2.458-.55l7.372-3.33a6.222 6.222 0 003.621-5.561v-.194c0-.388-.065-.776-.13-1.196L86.75 16.458h-.032a15.1 15.1 0 00-1.1-3.428 16.73 16.73 0 00-15.196-9.797 16.84 16.84 0 00-6.887 1.488zm-42.68 11.996v-2.392h3.75v2.392l-1.875 1.876-1.875-1.876zm49.793-.323c0-1.035.841-1.875 1.876-1.875 1.034 0 1.843.84 1.843 1.875 0 1.067-.809 1.875-1.843 1.875a1.856 1.856 0 01-1.876-1.875zm-26.933 4.85a4.367 4.367 0 014.365-4.365c2.392 0 4.332 1.94 4.332 4.365a4.333 4.333 0 01-4.332 4.333c-2.393 0-4.365-1.94-4.365-4.333zm31.751 0c0-1.035.84-1.875 1.875-1.875 1.035 0 1.876.84 1.876 1.875a1.877 1.877 0 01-3.75 0zm-9.668 0a1.877 1.877 0 013.75 0c.001 1.035-.84 1.875-1.874 1.875a1.877 1.877 0 01-1.876-1.875zm-40.416 0l1.875-1.875h2.36v3.75h-2.36l-1.875-1.875zm-9.571-1.875h2.393l1.875 1.875-1.875 1.875H15.81v-3.75zm5.044 6.402l1.875-1.876 1.876 1.876v2.36h-3.751v-2.36zm49.793.29c0-1.034.841-1.875 1.876-1.875 1.034 0 1.843.841 1.843 1.876 0 1.034-.809 1.875-1.843 1.875a1.877 1.877 0 01-1.876-1.875z",
  fill: "url(#icon-device--gaming_svg__a)"
}), React.createElement("circle", {
  fill: "#44484C",
  cx: 32.657,
  cy: 38.218,
  r: 4.365
}), React.createElement("circle", {
  fill: "#44484C",
  cx: 63.535,
  cy: 38.218,
  r: 4.365
}));

var SvgIconDeviceGaming = function SvgIconDeviceGaming(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 108 108",
    width: "1em",
    height: "1em",
    focusable: false
  }, props), React.createElement("title", null, title), _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/icon-device--gaming.7f88f60a.svg";
export { SvgIconDeviceGaming as ReactComponent };